module.exports = __webpack_public_path__ + "static/media/podcast_placeholder.b5c814ab.png";